/*
 * @Author: zhangjiangpo
 * @Date: 2023-08-30 13:59:51
 * @LastEditors: zhangjiangpo
 * @LastEditTime: 2024-04-17 11:10:56
 * @Description:
 */
export const columns = [
  {
    title: '姓名',
    dataIndex: 'studentName',
    fixed: 'left',
    width: 110,
    key: 'studentName',
    scopedSlots: { customRender: 'studentName' }
  },
  {
    title: '手机号',
    width: 120,
    fixed: 'left',
    dataIndex: 'telephone',
    key: 'telephone'
  },
  {
    title: '当前权益',
    width: 190,
    scopedSlots: { customRender: 'currentRights' }
  },
  {
    title: '助学师',
    width: 95,
    dataIndex: 'teacherName',
    key: 'teacherName'
  },
  {
    title: '小组名称',
    width: 150,
    dataIndex: 'groupName',
    key: 'groupName'
  },
  {
    title: '学年学期',
    width: 80,
    scopedSlots: { customRender: 'yearSemester' }
  },
  {
    title: '被分配课程',
    width: 200,
    dataIndex: 'itvCourseName',
    key: 'itvCourseName'
  },
  {
    title: '权益包类型',
    width: 90,
    scopedSlots: { customRender: 'rightsType' }
  },
  {
    title: '操作',
    fixed: 'right',
    width: 270,
    scopedSlots: { customRender: 'operation' }
  }
]